import { observer } from 'mobx-react';
import ParticipantStore from '../../../../../../ParticipantStore';
import { T } from '../../../../../../Translations';
import Modal from '../../../../../Modal';
import { AddLicenseToParticipantsStore } from '../Store';
import Body from './Body';
import { ModalFormState } from './Types';

interface Actions {
  submitting: () => void;
  waiting: () => void;
}

interface Props {
  state: ModalFormState;
  checkedParticipants: ParticipantStore[];
  actions: Actions;
  store: AddLicenseToParticipantsStore;
}

function ModalForm({ state, actions, checkedParticipants, store }: Props) {
  return (
    <Modal close={actions.waiting} modalWidth="w-2/4" title="">
      <div className="h-[600px]">
        <h2 className="text-xl font-semibold">
          <T kind="Manage Licenses for Participants" />
        </h2>
        <sub>
          <T kind="Allocate or release licenses for the participants below." />
        </sub>
        <Body
          state={state}
          submitting={actions.submitting}
          checkedParticipants={checkedParticipants}
          store={store}
        />
      </div>
    </Modal>
  );
}

export default observer(ModalForm);
